var scienceMediaTabs = {
  init: function () {
    $('.science-media-tabs').each(function () {
      var $section = $(this);

      function setActive(key) {
        if (!key) return;

        $section.find('.science-media-tabs__button').each(function () {
          var $button = $(this);
          var isActive = String($button.data('science-media-key')) === String(key);

          $button.toggleClass('active', isActive);
          $button.attr('aria-pressed', isActive);
        });

        $section.find('.science-media-tabs__media').each(function () {
          var $media = $(this);
          var isActive = String($media.data('science-media-key')) === String(key);

          $media.toggleClass('active', isActive);
          $media.find('video').each(function () {
            if (isActive) {
              this.play().catch(function () {});
            } else {
              this.pause();
            }
          });
        });
      }

      $section
        .find('.science-media-tabs__button')
        .off('click.scienceMediaTabs')
        .on('click.scienceMediaTabs', function () {
          setActive($(this).data('science-media-key'));
        });

      setActive($section.find('.science-media-tabs__button').first().data('science-media-key'));
    });
  }
};

$(document).ready(function () {
  scienceMediaTabs.init();
});

$(document).on('shopify:section:load', function () {
  scienceMediaTabs.init();
});
